// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-element-popup {
  background-color: var(--primary-bg-color);
  width: 610px;
  height: auto;
  padding: 60px 140px;
}

.form-element-popup .form-element-heading-title {
  font-weight: 600;
}

.form-element-popup-backdrop {
  background-color: #000a;
}

.form-element-popup-icon {
  margin: auto;
  width: 56px;
  height: 56px;
  line-height: 56px;
  text-align: center;
  margin-bottom: 24px;
  border-radius: 8px;
  font-size: 24px;
}

.popup-close-button {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 50%;
  background: #f5f5f5;
  color: #333;
  font-size: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.popup-close-button:hover {
  background: #e0e0e0;
}

.form-element-popup-icon[data-icon='info'] {
  background-color: #95b5f855;
  color: var(--primary-color-a-5);
}

.form-element-popup-icon[data-icon='error'] {
  background-color: #d2000055;
  color: var(--semantic-error-color);
}

.form-element-popup-icon[data-icon='warning'] {
  background-color: #fa9a3c55;
  color: var(--semantic-warning-color);
}

.form-element-popup-icon[data-icon='sucess'] {
  background-color: #22b17055;
  color: var(--semantic-success-color);
}

.form-element-popup-icon[data-icon='locked'] {
  background-color: #d2000055;
  color: var(--semantic-error-color);
}

.form-element-popup-icon[data-icon='pending'] {
  background-color: #fa9a3c55;
  color: var(--semantic-warning-color);
}

@media (max-width: 780px) {
  .react-popup-container {
    width: calc(100vw - 74px) !important;
    padding: 60px 24px;
    border-radius: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/form/popup/FormPopUp.css"],"names":[],"mappings":"AAAA;EACE,yCAAyC;EACzC,YAAY;EACZ,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;EACE,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;EACE,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;EACE;IACE,oCAAoC;IACpC,kBAAkB;IAClB,mBAAmB;EACrB;AACF","sourcesContent":[".form-element-popup {\n  background-color: var(--primary-bg-color);\n  width: 610px;\n  height: auto;\n  padding: 60px 140px;\n}\n\n.form-element-popup .form-element-heading-title {\n  font-weight: 600;\n}\n\n.form-element-popup-backdrop {\n  background-color: #000a;\n}\n\n.form-element-popup-icon {\n  margin: auto;\n  width: 56px;\n  height: 56px;\n  line-height: 56px;\n  text-align: center;\n  margin-bottom: 24px;\n  border-radius: 8px;\n  font-size: 24px;\n}\n\n.popup-close-button {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  width: 32px;\n  height: 32px;\n  border: none;\n  border-radius: 50%;\n  background: #f5f5f5;\n  color: #333;\n  font-size: 20px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.popup-close-button:hover {\n  background: #e0e0e0;\n}\n\n.form-element-popup-icon[data-icon='info'] {\n  background-color: #95b5f855;\n  color: var(--primary-color-a-5);\n}\n\n.form-element-popup-icon[data-icon='error'] {\n  background-color: #d2000055;\n  color: var(--semantic-error-color);\n}\n\n.form-element-popup-icon[data-icon='warning'] {\n  background-color: #fa9a3c55;\n  color: var(--semantic-warning-color);\n}\n\n.form-element-popup-icon[data-icon='sucess'] {\n  background-color: #22b17055;\n  color: var(--semantic-success-color);\n}\n\n.form-element-popup-icon[data-icon='locked'] {\n  background-color: #d2000055;\n  color: var(--semantic-error-color);\n}\n\n.form-element-popup-icon[data-icon='pending'] {\n  background-color: #fa9a3c55;\n  color: var(--semantic-warning-color);\n}\n\n@media (max-width: 780px) {\n  .react-popup-container {\n    width: calc(100vw - 74px) !important;\n    padding: 60px 24px;\n    border-radius: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
